module.exports = __webpack_public_path__ + "media/you-are-here.50d06f81.svg";